// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1f2a9","productName":"Table_productName__2n0an"};